export default function({ eventLabel, dataDictionary }) {
  const { dataLayer } = window;

  let event_data = {
    'event': eventLabel
  };
  for (var data_key of Object.keys(dataDictionary)) {
    event_data[data_key] = dataDictionary[data_key];
  }

  dataLayer.push(event_data);
}
